import { Link } from "@mui/material";
import "../_style.scss";
import { retireApllyFlg } from "../parts";
import { IAPI_RET011_Response } from "../../../type/apiType";
import { changeAmountFormat } from "../../../utils/useTools";

function GetBodyList(
  res: IAPI_RET011_Response,
  handleRetireeStatusClick: any,
  handleTotalBillingClick: any,
  handleLinkClick: any,
  search?: any
) {
  const CustomLink = (props: { name: string; item: any }) => {
    return (
      <Link
        onClick={() => handleTotalBillingClick(props.name, props.item, search)}
      >
        {props.name}
      </Link>
    );
  };

  const bodyList = res.retireeStatusList?.map((item) => [
    {
      children: (item.contractorNo ?? "") + ":" + (item.contractorName ?? ""),
      forSort: item.contractorNo,
    },
    {
      children: (item.staffNo ?? "") + ":" + (item.staffName ?? ""),
      forSort: item.staffNo,
    },
    {
      children:
        item.retireeStatus === "17" ? (
          retireApllyFlg[item.retireeStatus as keyof typeof retireApllyFlg]
        ) : (
          <Link onClick={() => handleRetireeStatusClick(item, search)}>
            {retireApllyFlg[item.retireeStatus as keyof typeof retireApllyFlg]}
          </Link>
        ),
      forSort: item.retireeStatus,
    },
    {
      children: item.retireDate,
      forSort: item.retireDate,
      align: "center",
    },
    {
      children: item.retireReasonCd,
      forSort: item.retireReasonCd,
    },
    {
      children: (
        <>
          {!item.retireApplCombBill ? (
            "-"
          ) : item.retireApplCombBill === "合算" ? (
            <div className="link">
              <CustomLink name="請求" item={item} />
              <CustomLink name="合算（再送）" item={item} />
            </div>
          ) : (
            <CustomLink name={item.retireApplCombBill} item={item} />
          )}
        </>
      ),
      forSort: item.retireApplCombBill,
    },
    {
      children:
        item.paymentStatus !== "未処理" && item.retireApllyFlg === "00"
        ? "-"
        : item.retireApplCombBill === "請求" && item.retireApllyFlg !== "00" ? (
          <Link onClick={() => handleLinkClick(item, search)}>
            {retireApllyFlg[item.retireApllyFlg as keyof typeof retireApllyFlg]}
          </Link>
        ) : (
          retireApllyFlg[item.retireApllyFlg as keyof typeof retireApllyFlg]
        ),
      forSort: item.retireApplCombBill,
    },
    {
      children: changeAmountFormat(item.retirementAllowanceAmt!),
      forSort: item.retirementAllowanceAmt,
      align: "right",
    },
    {
      children: item.domesticResidenceFlg === "0" ? "〇" : "",
      forSort: item.domesticResidenceFlg,
      align: "center",
    },
    {
      children: item.paymentStatus,
      forSort: item.paymentStatus,
    },
    {
      children: item.limitationDate,
      forSort: item.limitationDate,
      align: "center",
    },
  ]);

  return bodyList;
}

export { GetBodyList };
